export default "__VITE_ASSET__DgbWlXqz__"